{
  "name": "corkscrew",
  "doc": "Zoom plus a constant rotation: a line pulled into the centre while it turns - a corkscrew seen from the end. Faster than the tunnel, dizzier than the vortex.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.026,
  "zoomexp": 1.0,
  "rot": 0.022,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.96,
  "invert": 0,
  "hueShift": 0.004,
  "darkenCenter": 0.45,
  "wave": "LINE",
  "waveColor": 2,
  "shapes": 0,
  "energy": [
    0.6,
    1.0
  ]
}